import { render } from "./MoreBlogsComponent.vue?vue&type=template&id=7a1490e5"
import script from "./MoreBlogsComponent.vue?vue&type=script&lang=js"
export * from "./MoreBlogsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__